import { StaticText } from '@project_app/config/static.text';
import { NgxHmCarouselBreakPointUp, NgxHmCarouselComponent, NgxHmCarouselItemDirective } from 'ngx-hm-carousel';
import { Component, Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from '@app/core/components/base/base.component';
import { BannerService } from '@core/services/banner/banner.service';
import { FeatureToggleDirective } from '../../directives/feature-toggle.directive';
import { DeferImageLoadDirective } from '../../directives/defer-image-load.directive';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-image-slider',
    templateUrl: './image-slider.component.html',
    styleUrls: ['./image-slider.component.scss'],
    standalone: true,
    imports: [
        NgxHmCarouselComponent,
        NgxHmCarouselItemDirective,
        FormsModule,
        NgClass,
        DeferImageLoadDirective,
        FeatureToggleDirective
    ]
})
export class ImageSliderComponent extends BaseComponent {
    @Input() images = [];
    @Input() autoplay = false;
    @Input() categoryBanner?: boolean;
    @Input() referralBanner?: boolean;
    @Input() trackingBanner?: boolean;
    @Input() wrapperClass?: any;
    @Input() mainBanner?: boolean;
    @Input() bannerAlignment?: string;
    @Input() showIndicators = false;
    @Input() infiniteScroll = false;
    infiniteScrollEnabled = false;
    autoplayEnabled: boolean = false;

    menuBannerBreakPoint: NgxHmCarouselBreakPointUp[] = [{ width: 1024, number: 1.8 }];
    mobileSubBannerBreakPoint: NgxHmCarouselBreakPointUp[] = [{ width: 350, number: 1.3 }];
    mobileBannerBreakPoint: NgxHmCarouselBreakPointUp[] = [{ width: 350, number: 1.15 }];
    desktopBannerBreakPoint: NgxHmCarouselBreakPointUp[] = [
        { width: 800, number: 1 },
        { width: 1024, number: 3 }
    ];
    fullWithBannerMobile: NgxHmCarouselBreakPointUp[] = [
        { width: 350, number: 1 },
        { width: 800, number: 1 },
        { width: 1024, number: 3 }
    ];
    referralBannerBreakPoint: NgxHmCarouselBreakPointUp[] = [
        { width: 800, number: 1.15 },
        { width: 1024, number: 2.6 }
    ];
    trackingBannerBreakPoint: NgxHmCarouselBreakPointUp[] = [
        { width: 800, number: 1.65 },
        { width: 1024, number: 3.6 }
    ];

    currentIndex = 0;
    breakPoint: NgxHmCarouselBreakPointUp[];
    staticText: any = StaticText;

    constructor(private bannerService: BannerService) {
        super();
    }

    ngOnInitServer() {
        this.breakPoint = this.isMobile ? [{ width: 800, number: 1 }] : [{ width: 1024, number: 3 }];
    }

    ngOnInitBrowser() {
        this.bannerAlignment = this.bannerAlignment ? this.bannerAlignment : this.isMobile ? 'center' : 'left';
        this.setupBreakpoints();
        this.updateInfiniteScroll();
    }

    setupBreakpoints() {
        if (this.mainBanner) {
            this.breakPoint = this.isMobile ? this.mobileBannerBreakPoint : this.desktopBannerBreakPoint;
        } else if (this.categoryBanner) {
            this.breakPoint = this.fullWithBannerMobile;
        } else if (this.referralBanner) {
            this.breakPoint = this.referralBannerBreakPoint;
        } else if (this.trackingBanner) {
            this.breakPoint = this.trackingBannerBreakPoint;
        } else {
            this.breakPoint = this.isMobile ? this.mobileBannerBreakPoint : this.desktopBannerBreakPoint;
        }
    }

    updateInfiniteScroll() {
        this.infiniteScrollEnabled = this.infiniteScroll && this.images.length > 1;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.images) {
            this.updateInfiniteScroll();
        }
    }

    openActionLink(imageData: any, index: number) {
        this.bannerService.openActionLink(imageData, index);
    }
}